<template>
  <div class="inputbox" v-if="selectBank.id">
    <input
      name="amount"
      :type="inputType"
      :placeholder="
        $t(`deposit.inputLimit.${country}`, {
          minimum: formatMoney(selectBank.minimum, 0),
          maximum: formatMoney(selectBank.maximum, 0)
        })
      "
      v-model="value"
      min="1"
      @focus="onFocus"
      @blur="onBlur"
      @input="onInput"
      autocomplete="off"
    />
  </div>
</template>

<script>
import { formatMoney } from '@/utils/helper'

export default {
  props: {
    country: {
      type: String,
      default: 'ET'
    },
    inputType: {
      type: String,
      default: 'number'
    },
    inputAmount: {
      type: Number,
      default: 0
    },
    selectBank: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      value: ''
    }
  },
  watch: {
    inputAmount(val) {
      this.value = val
    }
  },
  mounted() {
    this.value = this.inputAmount
  },
  methods: {
    formatMoney,
    onInput(e) {
      this.$emit('input', e.target.value)
    },
    onFocus() {
      this.$emit('focus')
      this.$emit('input', '')
    },
    onBlur() {
      this.$emit('blur')
    }
  }
}
</script>

<style lang="scss" scoped>
.inputbox {
  line-height: 0.7rem;
  background-color: #fff;
  background-image: linear-gradient(#eeeeee, #fff 15%);
  display: inline-block;
  height: 0.7rem;
  width: 100%;
  border-radius: 0.1rem;
  font-size: 0.24rem;
  margin-bottom: 0.1rem;
  border: 1px solid #bec3c7;

  input {
    outline-style: none;
    outline-width: 0;
    border: none;
    border-style: none;
    text-shadow: none;
    -webkit-appearance: none;
    -webkit-user-select: text;
    outline-color: transparent;
    background-color: transparent;
    box-shadow: none;
    font-size: 0.24rem;
    line-height: 0.7rem;
    padding-left: 5%;
    width: 100%;
    color: #000;
  }

  input::placeholder {
    color: #95a5a5;
  }
}
</style>
